import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'authentication-layout',
	templateUrl: './authentication-layout.component.html',
	imports: [NgOptimizedImage, TranslateModule, RouterOutlet]
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class AuthenticationLayoutComponent {
}
